import { usePageTitle } from '@/hooks/usePageTitle';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { HUBSPOT_AUTH_MESSAGE, type HubSpotAuthMessage } from '@/lib/hubspotContext';

const PORTAL_STORAGE_KEY = 'hubspot_portal_id';

function AuthCallbackPage() {
  usePageTitle('HubSpot koppelen');
  const navigate = useNavigate();
  const params = useMemo(() => new URLSearchParams(window.location.search), []);

  useEffect(() => {
    const token = params.get('token');
    const portalId = params.get('portalId');
    const next = params.get('next');
    const close = params.get('close') === '1';
    const error = params.get('error');

    if (token) {
      localStorage.setItem('hubspot_token', token);
    }

    if (portalId) {
      localStorage.setItem(PORTAL_STORAGE_KEY, portalId);
    }

    if (close) {
      // De popup deelt geen storage met de HubSpot-card (iframe-storage is gepartitioneerd),
      // dus geven we de sessie door aan het venster dat deze flow startte.
      const message: HubSpotAuthMessage = {
        type: HUBSPOT_AUTH_MESSAGE,
        token: token ?? undefined,
        portalId: portalId ?? undefined,
        error: error ?? undefined,
      };
      window.opener?.postMessage(message, window.location.origin);

      if (!next) {
        window.close();
        return;
      }
    }

    if (error) {
      return;
    }

    const safeNext = next && next.startsWith('/') && !next.startsWith('//') ? next : '/';
    navigate(safeNext, { replace: true });
  }, [navigate, params]);

  const close = params.get('close') === '1';
  const error = params.get('error');

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <p className="mt-2 text-destructive">Verbinden mislukt</p>
            <p className="mt-1">{error}</p>
          </>
        ) : close ? (
          <p className="mt-2">Verbonden. Je kunt dit tabblad sluiten.</p>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto" />
            <p className="mt-2">Bezig met verbinden…</p>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthCallbackPage;
